export const ADMIN_LABELS = {
  doc_identita: "RICHIESTA DOCUMENTO D'IDENTITÀ",
  codice_fiscale: "RICHIESTA CODICE FISCALE",
  residenza: "RICHIESTA RESIDENZA",
  capitolato: "INVIO CAPITOLATO LAVORI CLIENTE",
  contratto: "INVIO CONTRATTO CLIENTE",
  privacy: "INVIO PRIVACY CLIENTE",
  iva: "INVIO AGEVOLAZIONE IVA CLIENTE",
  fatt_acconto: "FATTURAZIONE CLIENTE ACCONTO",
  fatt_forniture: "FATTURAZIONE FORNITURE",
  fatt_prodotti: "FATTURAZIONE PRODOTTI",
  fatt_sal1: "FATTURAZIONE CLIENTE SAL1",
  fatt_sal2: "FATTURAZIONE CLIENTE SAL2",
  fatt_extra1: "FATTURAZIONE CLIENTE EXTRA1",
  fatt_saldo: "FATTURAZIONE CLIENTE SALDO",
};

export const SUB_LABELS = {
  visura: "RICHIESTA VISURA SUBAPPALTO",
  durc: "RICHIESTA DURC SUBAPPALTO",
  polizza_rc: "RICHIESTA POLIZZA RC SUBAPPALTO",
  capitolato: "INVIO CAPITOLATO LAVORI SUBAPPALTO",
  contratto: "INVIO CONTRATTO SUBAPPALTO",
  pag_acconto: "PAGAMENTO SUBAPPALTO ACCONTO",
  pag_sal1: "PAGAMENTO SUBAPPALTO SAL1",
  pag_sal2: "PAGAMENTO SUBAPPALTO SAL2",
  pag_extra1: "PAGAMENTO SUBAPPALTO EXTRA1",
  cert_impianti: "CERTIFICAZIONI IMPIANTI",
  pag_saldo: "PAGAMENTO SUBAPPALTO SALDO",
};

const today = () => new Date().toLocaleDateString("en-CA");

export const dotTone = (s) => {
  if (!s) return ["bg-[#EBEBEB]", "—"];
  if (s.status === "completata") return ["bg-[#198754]", "Completata"];
  if (s.status === "non_serve") return ["bg-white border border-[#C8BDAB]", "Non serve"];
  if (s.expiry_date && s.expiry_date < today()) return ["bg-[#DC3545]", "Scaduto"];
  if (s.due_date && s.due_date < today()) return ["bg-[#DC3545]", "In ritardo"];
  if (s.status === "inviata" || s.prepared) return ["bg-[#F0AD4E]", s.prepared ? "Da emettere" : "In attesa"];
  return ["bg-[#D6D6D6]", "Da fare"];
};

export const Dot = ({ s, testid }) => {
  const [cls, title] = dotTone(s);
  return <span title={title} className={`inline-block h-3.5 w-3.5 rounded-full ${cls}`} data-testid={testid} />;
};

export const Legend = () => (
  <div className="flex flex-wrap gap-4 text-xs text-[#757575]" data-testid="status-legend">
    {[["bg-[#198754]", "Completata"], ["bg-[#F0AD4E]", "In attesa / da emettere"], ["bg-[#DC3545]", "In ritardo / scaduto"], ["bg-[#D6D6D6]", "Da fare"], ["bg-white border border-[#C8BDAB]", "Non serve"]].map(([c, l]) => (
      <span key={l} className="inline-flex items-center gap-1.5"><span className={`h-3 w-3 rounded-full ${c}`} />{l}</span>
    ))}
  </div>
);
